<template>
  <layout title="Co-Financed Projects">
    <JsonLd :entries="jsonLdEntries" />
    <div
      class="
        relative
        px-8
        pt-8
        pb-20
        mx-auto
        xl:px-5
        max-w-7xl
        sm:px-6
        lg:pt-10 lg:pb-28
      "
    >
      <div class="absolute inset-0">
        <div class="h-1/3 sm:h-2/3"></div>
      </div>
      <div class="relative mx-auto max-w-7xl">
        <div class="flex flex-col justify-start">
          <h1
            class="
              text-3xl
              font-extrabold
              leading-9
              tracking-tight
              text-gray-900
              sm:text-4xl sm:leading-10
            "
          >
            Co-Financed Projects
          </h1>
        </div>
        <div
          class="grid gap-5 mx-auto mt-12 sm:grid-cols-2 lg:grid-cols-3"
          v-if="posts"
        >
          <article
            :id="'post-' + post.id"
            class="flex flex-col overflow-hidden rounded-lg shadow-lg bg-white"
            typeof="Article"
            v-for="(post, index) in posts"
            :key="index"
          >
            <inertia-link :href="'projects/' + post.slug" class="h-full">
              <meta property="name" :content="post.title" />
              <meta property="author" typeof="Person" content="admin" />
              <meta
                property="dateModified"
                :content="post.updated_at | formatDate"
              />
              <meta
                class="uk-margin-remove-adjacent"
                property="datePublished"
                :content="post.created_at | formatDate"
              />
              <div class="flex flex-col justify-between h-full">
                <div>
                  <div class="shrink-0" v-if="post.image">
                    <img
                      class="object-cover w-full h-48"
                      :src="aws_image_path + post.image"
                      alt=""
                    />
                  </div>
                  <div
                    class="relative flex flex-col justify-between flex-1 p-6"
                  >
                    <div class="flex-1">
                      <h3
                        class="
                          mt-2
                          text-xl
                          font-semibold
                          leading-7
                          text-gray-900
                        "
                      >
                        {{ post.title }}
                      </h3>
                      <p class="mt-3 text-base leading-6 text-gray-500">
                        {{
                          post.body.length > 200
                            ? removeHTMLtags(post.body).substring(0, 200) +
                              "..."
                            : removeHTMLtags(post.body)
                        }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </inertia-link>
          </article>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
const layout = () =>
  import(/* webpackChunkName: "layout" */ "../Components/Layout/layout.vue");
import JsonLd from "../Components/SEO/JsonLd.vue";
import { buildCollectionPageSchema } from "../utils/structuredData";

export default {
  props: {
    errors: Object,
  },
  components: { layout, JsonLd },
  data() {
    return {
      posts: null,
      aws_image_path: process.env.MIX_IMAGES_PATH,
    };
  },
  created() {
    this.getBlog();
  },
  computed: {
    jsonLdEntries() {
      return [
        buildCollectionPageSchema({
          items: (this.posts || []).map((post) => ({
            name: post.title,
            url: `/resources/projects/${post.slug}`,
          })),
        }),
      ];
    },
  },
  methods: {
    removeHTMLtags(text) {
      return text.replace(/(<([^>]+)>)/gi, "");
    },
    getBlog() {
      this.axios.get("/api/projects").then((response) => {
        this.posts = response.data;
      });
    },
  },
};
</script>
